module.exports = __webpack_public_path__ + "img/logo.bfada98f.png";